import(/* webpackMode: "eager" */ "/app/src/app/badge/[id]/page.js");
